
// Dependencies
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'customer-quotes-component',
  components: { Carousel, Slide }

  /*
  data () {
    return {
      quotes: [
        {
          name: 'Melané',
          country: 'France',
          stars: 5,
          quote: 'I\'m a huge fan of Ingela\'s illustrations and I was really happy to discover her work for and with Born This Day!'
        },
        {
          name: 'Emma Green',
          country: 'Sweden',
          stars: 5,
          quote: 'So happy for our Bente poster, which suits well in the child\'s room here at home. Extra fun that it is personal.'
        },
        {
          name: 'Nowelnn',
          country: 'France',
          stars: 5,
          quote: 'The posters are really beautiful. It fits well with my vintage style in my child\'s room. I\'m more than happy!'
        },
        {
          name: 'Sara',
          country: 'Sweden',
          stars: 5,
          quote: 'The service was top class and I can really recommend others to shop here.'
        }
      ],
      showIndex: 0
    }
  },
  */

  // computed: {
  //   quote () {
  //     if (this.quotes.length <= this.showIndex) {
  //       return this.quotes[0]
  //     }
  //     return this.quotes[this.showIndex]
  //   }
  // },
  /*
  methods: {
    setIndex (index) {
      this.showIndex = index
    }
  }
  */
}



// WEBPACK FOOTER //
// ./src/components/customer-quotes/script.js